module.exports = __webpack_public_path__ + "icons/money-stack-d300f79c47dd39caee084bd8a9f3683c.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/money-stack.svg
// module id = slC8
// module chunks = 23